import { useState } from "react";
import { LoginLogDto } from "../types/loginLog";
import { loginLogService } from "../services/loginLogService";
import { useApi } from "./useApi";

export const useLoginLogs = () => {
  // 1. Το GET γίνεται αυτόματα με το useApi, cache, signal και error handling
  const {
    data: loginLogs = [],
    loading: isLoading,
    error,
    refetch: fetchLoginLogs,
  } = useApi<LoginLogDto[]>("login-logs", (signal) => loginLogService.getAll({}, signal));

  const [modalState, setModalState] = useState<{
    isOpen: boolean;
    title: string;
    message: string;
    type: "success" | "error";
  }>({
    isOpen: false,
    title: "",
    message: "",
    type: "success",
  });

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  return {
    loginLogs,
    isLoading,
    error,
    fetchLoginLogs: () => fetchLoginLogs(true),
    modalState,
    closeModal,
  };
};